var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 3.33332H20V0.666656H17.3333V3.33332H6.66667V0.666656H4V3.33332H2.66667C1.18667 3.33332 0.0133333 4.53332 0.0133333 5.99999L0 24.6667C0 25.3739 0.280951 26.0522 0.781048 26.5523C1.28115 27.0524 1.95942 27.3333 2.66667 27.3333H21.3333C22.8 27.3333 24 26.1333 24 24.6667V5.99999C24 4.53332 22.8 3.33332 21.3333 3.33332ZM21.3333 24.6667H2.66667V11.3333H21.3333V24.6667ZM8 16.6667H5.33333V14H8V16.6667ZM13.3333 16.6667H10.6667V14H13.3333V16.6667ZM18.6667 16.6667H16V14H18.6667V16.6667ZM8 22H5.33333V19.3333H8V22ZM13.3333 22H10.6667V19.3333H13.3333V22ZM18.6667 22H16V19.3333H18.6667V22Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.080c75d6.svg";
export { ForwardRef as ReactComponent };